import React from "react";
import { OuterContainer, ImageBorder, ImageContainer, StyledImage } from "./styled";
export var DEFAULT_SIZE = 150;
export var DEFAULT_BORDER_SIZE = 10;
var Image = function (_a) {
    var image = _a.image, alt = _a.alt, size = _a.size, border = _a.border, alignLeft = _a.alignLeft, backgroundColor = _a.backgroundColor;
    return (React.createElement(ImageContainer, { size: size },
        React.createElement(OuterContainer, { size: size },
            React.createElement(ImageBorder, { size: size, border: border, alignLeft: alignLeft, backgroundColor: backgroundColor },
                React.createElement(StyledImage, { src: image, size: size - border, alt: alt, noBorderRadius: backgroundColor === "transparent" })))));
};
Image.defaultProps = {
    size: DEFAULT_SIZE,
    border: DEFAULT_BORDER_SIZE
};
export default Image;
